import Head from 'next/head'

const themes = {
  orange: {
    '--color-primary': '#D3411C',
    '--color-secondary': '#1F2832',
    '--color-white': '#FFFFFF',
    '--color-grey': '#545454'
  }
}

export default function ThemeStyles() {
  const themeColor = 'orange'

  return (
    <Head>
      <style>{`
        :root {
          --color-primary: ${themes[themeColor]['--color-primary']};
          --color-secondary: ${themes[themeColor]['--color-secondary']};
          --color-white: ${themes[themeColor]['--color-white']};
          --color-grey: ${themes[themeColor]['--color-grey']};
        }
      `}</style>
    </Head>
  )
}
